import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { TrendingUp, Users, ArrowUpRight, Maximize2 } from 'lucide-react';

const WorkplaceAnalytics: React.FC = () => {
  // Mock data - in real app this would come from sensors
  const weeklyData = [
    { day: 'Mon', occupancy: 65, efficiency: 72 },
    { day: 'Tue', occupancy: 72, efficiency: 78 },
    { day: 'Wed', occupancy: 85, efficiency: 82 },
    { day: 'Thu', occupancy: 78, efficiency: 75 },
    { day: 'Fri', occupancy: 70, efficiency: 68 },
    { day: 'Sat', occupancy: 45, efficiency: 55 },
    { day: 'Sun', occupancy: 35, efficiency: 45 }
  ];

  const metrics = {
    currentOccupancy: 72,
    peakHours: '10:00 AM - 2:00 PM',
    spaceEfficiency: 78,
    utilizationTrend: '+8%'
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-6">Workplace Analytics</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center mb-2">
            <Users className="text-blue-500 mr-2" />
            <h3 className="text-lg font-semibold">Current Occupancy</h3>
          </div>
          <p className="text-3xl font-bold">{metrics.currentOccupancy}%</p>
          <p className="text-gray-500">of total capacity</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center mb-2">
            <TrendingUp className="text-green-500 mr-2" />
            <h3 className="text-lg font-semibold">Peak Hours</h3>
          </div>
          <p className="text-3xl font-bold">{metrics.peakHours}</p>
          <p className="text-gray-500">highest activity</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center mb-2">
            <Maximize2 className="text-purple-500 mr-2" />
            <h3 className="text-lg font-semibold">Space Efficiency</h3>
          </div>
          <p className="text-3xl font-bold">{metrics.spaceEfficiency}%</p>
          <p className="text-gray-500">optimal usage</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <div className="flex items-center mb-2">
            <ArrowUpRight className="text-orange-500 mr-2" />
            <h3 className="text-lg font-semibold">Utilization Trend</h3>
          </div>
          <p className="text-3xl font-bold">{metrics.utilizationTrend}</p>
          <p className="text-gray-500">vs last week</p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-6">
        <div className="bg-white rounded-lg shadow p-6">
          <h3 className="text-xl font-semibold mb-4">Weekly Occupancy Trend</h3>
          <ResponsiveContainer width="100%" height={400}>
            <LineChart data={weeklyData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="day" />
              <YAxis />
              <Tooltip />
              <Legend />
              <Line 
                type="monotone" 
                dataKey="occupancy" 
                stroke="#8884d8" 
                name="Occupancy %"
                strokeWidth={2}
              />
              <Line 
                type="monotone" 
                dataKey="efficiency" 
                stroke="#82ca9d" 
                name="Space Efficiency %"
                strokeWidth={2}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default WorkplaceAnalytics; 